{
  "version": "0.0.0",
  "id": "at.softline.greiner.softline",
  "name": "Greiner Softline"
}
